export const ICON_MARRIED = `<svg class="ccc_icon" height="16" viewBox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg" fill="none" stroke="currentColor"><circle cx="5" cy="8" r="4.5"/><circle cx="11" cy="8" r="4.5"/></svg>`
